import React, { useState } from 'react';
import Button from '../../../../component/ui/Button';
import Modal from '../../../../component/modal/Modal';
import InputField from '../../../../component/form/FormInput';
import { createPaymentMethod } from '../../../../services/payment_methods';
import usePaymentMethod from '../../hooks/usePaymentMethod';
import { toast } from 'react-toastify';

function AddPaymentMethodModal({
	isAddPaymentMethod,
	setIsAddPaymentMethod,
	setIsPaymentMethodFocus,
	setPurchaseBillFormData,
	paymentMethodList = [],
	type,
}) {
	const [paymentMethod, setPaymentMethod] = useState('');
	const [errorPaymentMethod, setErrorPaymentMethod] = useState('');
	const { setPaymentMethodList } = usePaymentMethod();

	const handleAddPaymentMethod = async () => {
		try {
			if (paymentMethod === '') {
				setErrorPaymentMethod('Please enter payment method name!');
			}
			const data = await createPaymentMethod({ payment_method_name: paymentMethod });
			const updatePaymentMethodList = [
				{
					key: data.paymentMethod?.payment_method_id,
					value: data.paymentMethod?.payment_method_name,
				},
			];
			setPaymentMethodList(updatePaymentMethodList);
			if (type !== 'pb') {
				paymentMethodList.push({
					key: data.paymentMethod?.payment_method_id,
					value: data.paymentMethod?.payment_method_name,
				});
			}
			setPurchaseBillFormData((prev) => ({
				...prev,
				payment_method:
					type === 'pb'
						? data.paymentMethod?.payment_method_name
						: data.paymentMethod?.payment_method_id,
			}));
			setIsAddPaymentMethod(false);
			setIsPaymentMethodFocus(true);
		} catch (error) {
			toast.error('Something went wrong!');
		}
	};

	return (
		<Modal
			className="delivery-modal"
			title="Payment Method"
			isOpen={isAddPaymentMethod}
			onClose={() => {
				setIsAddPaymentMethod(false);
				setIsPaymentMethodFocus(true);
			}}
			cancelButton={true}
		>
			<p>
				<InputField
					label="Payment Method"
					placeholder="Enter Payment Method"
					autoComplete={'Payment Method'}
					name="Payment Method"
					value={paymentMethod}
					onChange={(value) => {
						if (value !== '' && value !== null) {
							setPaymentMethod(value);
							setErrorPaymentMethod('');
						} else {
							setPaymentMethod('');
							setErrorPaymentMethod('Please enter payment method');
						}
					}}
					onKeyPress={(e) => {
						if ((e.key === 'Enter' || e.key === 'enter') && paymentMethod !== '') {
							handleAddPaymentMethod();
						}
					}}
					autoFocus={true}
					required={true}
					error={errorPaymentMethod}
				/>
			</p>

			<div
				style={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'flex-end',
					marginTop: '20px',
				}}
			>
				<Button
					button="Cancel"
					type="button"
					className="btn btn-danger"
					onClick={() => {
						setPaymentMethod('');
						setIsAddPaymentMethod(false);
						setIsPaymentMethodFocus(true);
					}}
				/>
				<span style={{ width: '20px' }}></span>
				<Button
					button="OK"
					type="button"
					className="btn btn-primary"
					onClick={handleAddPaymentMethod}
				/>
			</div>
		</Modal>
	);
}

export default AddPaymentMethodModal;
